export const FETCH_EMAIL = "fetchEmail"
export const FETCH_EVENT = "fetchEvent"
export const FETCH_SUMMARIZE_EVENT = "fetchSummrizeEvent"
export const SET_RESERVER = "setReserver"
export const FETCH_SURVEY_QUESTION = "fetchSurveyQuestion"


